import { NgModule } from "@angular/core";
import { SplitViewModule } from "../proofreading/split-view.module";
import { MaterialModule } from "../material.module";
import { SharedModule } from "../shared/shared.module";
import { ProjectDashboardComponent } from "./project-dashboard/project-dashboard.component";
import { ProjectFiltersComponent } from "./project-filters/project-filters.component";
import { RecentProjectCardsComponent } from "./recent-project-cards/recent-project-cards.component";
import { ProjectsMasterCardsComponent } from "./project-master-card/project-master-card.component";
import { DashboardHistoryDetailComponent } from "./dashboard-history-detail/dashboard-history-detail.component";
import { ProjectsChildCardsComponent } from "./project-child-card/project-child-card.component";
import { ProjectDashboardRoutingModule } from "./project-dashboard.routing.module";
import { ProjectsCardsSkeletonComponent } from "./project-cards-skeleton/project-cards-skeleton.component";


@NgModule({
    declarations: [
        ProjectDashboardComponent,
        ProjectFiltersComponent,
        RecentProjectCardsComponent,
        ProjectsMasterCardsComponent,
        ProjectsChildCardsComponent,
        DashboardHistoryDetailComponent,
        ProjectsCardsSkeletonComponent
    ],
    imports: [
        ProjectDashboardRoutingModule,
        SharedModule,
        MaterialModule,
        SplitViewModule,
    ],
    exports: [
        ProjectFiltersComponent
    ],
    providers: [],
    bootstrap: []
})
export class ProjectDashboardModule { }
